import React from "react";
import s from "../labReportPdf.module.scss";

const StoolReport = ({ profile, PageBaseLayout, PageFooter }) => {
  const macroKeywords = ["Color", "Consistency", "Mucus", "Reaction"];

  const macroTests = profile.tests.filter((t) =>
    macroKeywords.some((key) =>
      t.testName.toLowerCase().includes(key.toLowerCase()),
    ),
  );
  const microTests = profile.tests.filter((t) => !macroTests.includes(t));

  const RenderSection = ({ title, tests }) => (
    <>
      <tr className={s.sectionHeaderRow}>
        <td
          colSpan="4"
          style={{
            fontWeight: "bold",
            backgroundColor: "#f2f2f2",
            padding: "8px",
            textAlign: "left",
            textTransform: "uppercase",
          }}
        >
          {title}
        </td>
      </tr>
      {tests.map((t, idx) => (
        <tr key={idx}>
          <td style={{ paddingLeft: "15px", borderBottom: "1px solid #eee" }}>
            {t.testName}
          </td>
          <td align="center" style={{ borderBottom: "1px solid #eee" }}>
            {t.value || "-"}
          </td>
          <td align="center" style={{ borderBottom: "1px solid #eee" }}>
            {t.units || "-"}
          </td>
          <td align="center" style={{ borderBottom: "1px solid #eee" }}>
            {t.reference_range_details || "N/A"}
          </td>
        </tr>
      ))}
    </>
  );

  return (
    <div className={s.reportPage} style={{ pageBreakAfter: "always" }}>
      <PageBaseLayout showSampleType={true} currentSampleType={profile.sampleType} />
      <div className={s.testCategoryHeader}>
        {profile.profileName.toUpperCase()}
      </div>

      <table
        className={s.resultsTable}
        style={{ width: "100%", borderCollapse: "collapse" }}
      >
        <thead>
          <tr style={{ backgroundColor: "#fafafa" }}>
            <th style={{ width: "40%", textAlign: "left", padding: "8px" }}>
              Test Description
            </th>
            <th style={{ textAlign: "center" }}>Value(s)</th>
            <th style={{ textAlign: "center" }}>Unit(s)</th>
            <th style={{ textAlign: "center" }}>Reference Range</th>
          </tr>
        </thead>
        <tbody>
          {macroTests.length > 0 && (
            <RenderSection title="MACROSCOPIC" tests={macroTests} />
          )}
          {microTests.length > 0 && (
            <RenderSection title="MICROSCOPIC" tests={microTests} />
          )}
        </tbody>
      </table>

     

      <PageFooter />
    </div>
  );
};

export default StoolReport;
